import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge, Nav, Tab, Modal, Form, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt, FaKey, FaUser, FaRupeeSign, FaClock, FaCreditCard, FaMoneyBillWave, FaPlus, FaEdit, FaCalendarAlt, FaSearch, FaFileExport, FaPhoneAlt, FaWhatsapp, FaCertificate, FaEye, FaTrash, FaChalkboardTeacher } from 'react-icons/fa';
import AdminUsecase from '../../lib/usecase/AdminUsecase';
import StudentAttendacne from './StudentAttendacne';

const CERTIFICATE_CACHE_KEY = 'adminCertificatesCache';
const CERTIFICATE_PREVIEW_KEY = 'adminCertificatePreview';

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('attendance');
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalCourses: 0,
    totalEnrollments: 0,
    totalRevenue: 0
  });
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [students, setStudents] = useState([]);
  const [courses, setCourses] = useState([]);
  const [enrollments, setEnrollments] = useState([]);
  const [financialStats, setFinancialStats] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [pendingFees, setPendingFees] = useState([]);
  const [certificates, setCertificates] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const navigate = useNavigate();

  // Modal states
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [showEnrollModal, setShowEnrollModal] = useState(false);
  const [showAddCourseModal, setShowAddCourseModal] = useState(false);
  const [showEditCourseModal, setShowEditCourseModal] = useState(false);
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [showCertificateViewModal, setShowCertificateViewModal] = useState(false);
  const [showTeacherModal, setShowTeacherModal] = useState(false);
  const [showStudentStatusModal, setShowStudentStatusModal] = useState(false);
  const [selectedStudentStatusChange, setSelectedStudentStatusChange] = useState(null);

  // Form data states
  const [studentFormData, setStudentFormData] = useState({
    full_name: '',
    email: '',
    phone_number: '',
    dob: '',
    course_id: '',
    enrollment_mode: 'online',
    payment_mode: 'full',
    total_amount: '',
    installment_count: 3,
    installment_amount: '',
    first_installment_date: ''
  });

  // Enroll existing student form (course + payment only)
  const [enrollFormData, setEnrollFormData] = useState({
    course_id: '',
    enrollment_mode: 'online',
    payment_mode: 'full',
    total_amount: '',
    installment_count: 3,
    installment_amount: '',
    first_installment_date: ''
  });
  const [selectedStudentForEnroll, setSelectedStudentForEnroll] = useState(null);
  const [enrollFormError, setEnrollFormError] = useState('');
  const [enrollFormSuccess, setEnrollFormSuccess] = useState('');

  const [courseFormData, setCourseFormData] = useState({
    title: '',
    description: '',
    price: '',
    duration: '',
    category: '',
    level: 'beginner',
    image_url: '',
    is_active: true
  });

  const [accountFormData, setAccountFormData] = useState({
    description: '',
    credit: false,
    txn_date: new Date().toISOString().split('T')[0],
    amount: ''
  });

  const [editingCourse, setEditingCourse] = useState(null);

  // Build phone links for dial and WhatsApp with basic sanitation
  const buildContactLinks = (raw) => {
    if (!raw) return { telHref: null, waHref: null };
    const digits = String(raw).replace(/[^\d+]/g, '');
    const telHref = digits ? `tel:${digits}` : null;
    let waDigits = digits.replace(/\+/g, '');
    if (/^\d{10}$/.test(waDigits)) {
      // Assume India if 10-digit local number
      waDigits = `91${waDigits}`;
    }
    const waHref = /^\d{11,15}$/.test(waDigits) ? `https://wa.me/${waDigits}` : null;
    return { telHref, waHref };
  };
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');
  const [accountFormError, setAccountFormError] = useState('');
  const [accountFormSuccess, setAccountFormSuccess] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchStudents, setSearchStudents] = useState('');
  const [searchCourses, setSearchCourses] = useState('');
  const [searchEnrollments, setSearchEnrollments] = useState('');
  const [searchFees, setSearchFees] = useState('');
  const [showOnlyEnabledStudentFees, setShowOnlyEnabledStudentFees] = useState(true);
  const [searchCertificates, setSearchCertificates] = useState('');
  const [certificateStudentSearch, setCertificateStudentSearch] = useState('');
  const [certificateFormData, setCertificateFormData] = useState({
    user_id: '',
    enrollment_id: '',
    course_id: '',
    course_name: '',
    certificate_number: '',
    grade: '',
    instructor_name: '',
    course_duration: '',
    completion_date: '',
    issue_date: '',
    certificate_url: '',
    is_valid: true
  });
  const [certificateFormError, setCertificateFormError] = useState('');
  const [certificateFormSuccess, setCertificateFormSuccess] = useState('');
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [certificateActionLoadingId, setCertificateActionLoadingId] = useState('');
  const [searchTeachers, setSearchTeachers] = useState('');
  const [teacherModalMode, setTeacherModalMode] = useState('add');
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [teacherFormData, setTeacherFormData] = useState({
    full_name: '',
    email: '',
    phone_number: '',
    joining_date: '',
    salary: '',
    password: '',
    designation: 'teacher',
    address: '',
    is_active: true
  });
  const [teacherFormError, setTeacherFormError] = useState('');
  const [teacherFormSuccess, setTeacherFormSuccess] = useState('');

  // Attendance moved to StudentAttendacne component

  // Course categories (same values as src/pages/Courses.js#L19-28)
  const courseCategoryOptions = [
    { value: 'all', label: 'All Courses' },
    { value: 'web', label: 'Web Development' },
    { value: 'mobile', label: 'Mobile Development' },
    { value: 'data', label: 'Data Science' },
    { value: 'marketing', label: 'Digital Marketing' },
    { value: 'design', label: 'UI/UX Design' },
    { value: 'programming', label: 'Programming' },
    { value: 'cloud', label: 'Cloud Computing' }
  ];

  // Helper: format date as "12 Sep 2025"
  const formatDateShort = (dateStr) => {
    if (!dateStr) return '—';
    const d = new Date(dateStr);
    if (isNaN(d)) return '—';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
  };

  // Filter accounts by search query
  const getFilteredAccounts = () => {
    const q = (searchQuery || '').trim().toLowerCase();
    if (!q) return accounts;
    return (accounts || []).filter((row) => {
      const desc = String(row.description || '').toLowerCase();
      const type = row.credit ? 'credit' : 'debit';
      const amtStr = typeof row.amount === 'number' ? row.amount.toString() : String(row.amount || '');
      const dateStr = formatDateShort(row.txn_date).toLowerCase();
      return desc.includes(q) || type.includes(q) || amtStr.includes(q) || dateStr.includes(q);
    });
  };

  const handleExportAccounts = () => {
    try {
      const data = getFilteredAccounts();
      const header = ['Description', 'Amount', 'Type', 'Transaction Date', 'Balance'];
      const rows = data.map((r) => [
        r.description ?? '',
        Number(r.amount ?? 0),
        r.credit ? 'Credit' : 'Debit',
        formatDateShort(r.txn_date),
        Number(r.balance ?? 0),
      ]);
      const escape = (val) => String(val).replace(/"/g, '""');
      const csv = [header, ...rows]
        .map((row) => row.map((f) => `"${escape(f)}"`).join(','))
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `accounts_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export error:', err);
    }
  };

  // Students: filter and export
  const getFilteredStudents = () => {
    const q = (searchStudents || '').trim().toLowerCase();
    if (!q) return students;
    return (students || []).filter((s) => {
      const name = String(s.full_name || s.name || '').toLowerCase();
      const email = String(s.email || '').toLowerCase();
      const course = String(s.course_title || '').toLowerCase();
      const status = s.is_active ? 'active' : 'inactive';
      return name.includes(q) || email.includes(q) || course.includes(q) || status.includes(q);
    });
  };

  const handleExportStudents = () => {
    try {
      const data = getFilteredStudents();
      const header = ['ID', 'Name', 'Email', 'Course', 'Status'];
      const rows = (data || []).map((s) => [
        s.id ?? '',
        s.full_name || s.name || '',
        s.email || '',
        s.course_title || '',
        s.is_active ? 'Active' : 'Inactive',
      ]);
      const escape = (val) => String(val).replace(/"/g, '""');
      const csv = [header, ...rows]
        .map((row) => row.map((f) => `"${escape(f)}"`).join(','))
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `students_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export students error:', err);
    }
  };

  // Courses: filter and export
  const getFilteredCourses = () => {
    const q = (searchCourses || '').trim().toLowerCase();
    if (!q) return courses;
    return (courses || []).filter((c) => {
      const title = String(c.title || '').toLowerCase();
      const priceStr = typeof c.price === 'number' ? c.price.toString() : String(c.price || '');
      const status = c.is_active ? 'active' : 'inactive';
      const enrollStr = (c.enrollment_count || 0).toString();
      return title.includes(q) || priceStr.includes(q) || status.includes(q) || enrollStr.includes(q);
    });
  };

  const handleExportCourses = () => {
    try {
      const data = getFilteredCourses();
      const header = ['ID', 'Course Title', 'Students', 'Price', 'Status'];
      const rows = (data || []).map((c) => [
        c.id ?? '',
        c.title || '',
        c.enrollment_count || 0,
        typeof c.price === 'number' ? c.price : (c.price || ''),
        c.is_active ? 'Active' : 'Inactive',
      ]);
      const escape = (val) => String(val).replace(/"/g, '""');
      const csv = [header, ...rows]
        .map((row) => row.map((f) => `"${escape(f)}"`).join(','))
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `courses_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export courses error:', err);
    }
  };

  // Enrollments: filter and export
  const getFilteredEnrollments = () => {
    const q = (searchEnrollments || '').trim().toLowerCase();
    if (!q) return enrollments;
    return (enrollments || []).filter((e) => {
      const student = String(e.student_name || e.user_email || '').toLowerCase();
      const course = String(e.course_title || '').toLowerCase();
      const dateStr = e.created_at ? formatDateShort(e.created_at).toLowerCase() : '';
      const status = e.is_active ? 'active' : 'inactive';
      const progressStr = (e.progress || 0).toString();
      return student.includes(q) || course.includes(q) || dateStr.includes(q) || status.includes(q) || progressStr.includes(q);
    });
  };

  const handleExportEnrollments = () => {
    try {
      const data = getFilteredEnrollments();
      const header = ['ID', 'Student', 'Course', 'Enrollment Date', 'Progress', 'Status'];
      const rows = (data || []).map((e) => [
        e.id ?? '',
        e.student_name || e.user_email || '',
        e.course_title || '',
        e.created_at ? formatDateShort(e.created_at) : '',
        e.progress || 0,
        e.is_active ? 'Active' : 'Inactive',
      ]);
      const escape = (val) => String(val).replace(/"/g, '""');
      const csv = [header, ...rows]
        .map((row) => row.map((f) => `"${escape(f)}"`).join(','))
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `enrollments_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export enrollments error:', err);
    }
  };

  // Pending Fees (Financial): filter and export
  const getFilteredPendingFees = () => {
    const baseFees = showOnlyEnabledStudentFees
      ? (pendingFees || []).filter((f) => f.is_active !== false)
      : (pendingFees || []);
    const q = (searchFees || '').trim().toLowerCase();
    if (!q) return baseFees;
    return baseFees.filter((f) => {
      const student = String(f.student_name || '').toLowerCase();
      const course = String(f.course_title || '').toLowerCase();
      const installment = `${f.installment_number}/${f.total_installments}`.toLowerCase();
      const amountStr = (typeof f.amount === 'number' ? f.amount.toString() : String(f.amount || ''));
      const dueStr = formatDateShort(f.due_date).toLowerCase();
      const overdue = f.status === 'overdue' || (f.due_date && new Date(f.due_date) < new Date());
      const status = overdue ? 'overdue' : 'pending';
      return student.includes(q) || course.includes(q) || installment.includes(q) || amountStr.includes(q) || dueStr.includes(q) || status.includes(q);
    });
  };

  const handleExportPendingFees = () => {
    try {
      const data = getFilteredPendingFees();
      const header = ['Student', 'Course', 'Installment', 'Amount', 'Due Date', 'Status'];
      const rows = (data || []).map((f) => {
        const overdue = f.status === 'overdue' || (f.due_date && new Date(f.due_date) < new Date());
        return [
          f.student_name || '',
          f.course_title || '',
          `${f.installment_number}/${f.total_installments}`,
          typeof f.amount === 'number' ? f.amount : (f.amount || ''),
          formatDateShort(f.due_date),
          overdue ? 'Overdue' : 'Pending',
        ];
      });
      const escape = (val) => String(val).replace(/"/g, '""');
      const csv = [header, ...rows]
        .map((row) => row.map((f) => `"${escape(f)}"`).join(','))
        .join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `pending_fees_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export pending fees error:', err);
    }
  };

  const getFilteredCertificates = () => {
    const q = (searchCertificates || '').trim().toLowerCase();
    if (!q) return certificates;
    return (certificates || []).filter((c) => {
      const certNo = String(c.certificate_number || '').toLowerCase();
      const student = String(c.student_name || '').toLowerCase();
      const course = String(c.course_name || '').toLowerCase();
      const grade = String(c.grade || '').toLowerCase();
      return certNo.includes(q) || student.includes(q) || course.includes(q) || grade.includes(q);
    });
  };

  const getFilteredTeachers = () => {
    const q = (searchTeachers || '').trim().toLowerCase();
    if (!q) return teachers;
    return (teachers || []).filter((teacher) => {
      const name = String(teacher.full_name || '').toLowerCase();
      const email = String(teacher.email || '').toLowerCase();
      const phone = String(teacher.phone_number || '').toLowerCase();
      const designation = String(teacher.designation || '').toLowerCase();
      const status = teacher.is_active ? 'active' : 'inactive';
      return (
        name.includes(q) ||
        email.includes(q) ||
        phone.includes(q) ||
        designation.includes(q) ||
        status.includes(q)
      );
    });
  };

  const resetTeacherForm = () => {
    setTeacherFormData({
      full_name: '',
      email: '',
      phone_number: '',
      joining_date: '',
      salary: '',
      password: '',
      designation: 'teacher',
      address: '',
      is_active: true
    });
    setTeacherFormError('');
    setTeacherFormSuccess('');
    setSelectedTeacher(null);
    setTeacherModalMode('add');
  };

  const openTeacherModal = (mode, teacher = null) => {
    setTeacherModalMode(mode);
    setSelectedTeacher(teacher);
    setTeacherFormError('');
    setTeacherFormSuccess('');

    if (teacher) {
      setTeacherFormData({
        full_name: teacher.full_name || '',
        email: teacher.email || '',
        phone_number: teacher.phone_number || '',
        joining_date: teacher.joining_date || '',
        salary: teacher.salary ?? '',
        password: '',
        designation: teacher.designation || 'teacher',
        address: teacher.address || '',
        is_active: teacher.is_active !== false
      });
    } else {
      resetTeacherForm();
      setTeacherModalMode(mode);
    }

    setShowTeacherModal(true);
  };

  const selectedEnrollmentsForCertificate = (enrollments || []).filter(
    (e) => String(e.student_id) === String(certificateFormData.user_id)
  );

  const filteredStudentsForCertificate = (students || []).filter((student) => {
    const query = (certificateStudentSearch || '').trim().toLowerCase();
    if (!query) return true;

    const name = String(student.full_name || student.name || '').toLowerCase();
    const email = String(student.email || '').toLowerCase();
    const phone = String(student.phone_number || '').toLowerCase();
    return name.includes(query) || email.includes(query) || phone.includes(query);
  });

  const handleCertificateStudentChange = (studentId) => {
    setCertificateFormData((prev) => ({
      ...prev,
      user_id: studentId,
      enrollment_id: '',
      course_id: '',
      course_name: '',
      course_duration: ''
    }));
    setCertificateFormError('');
    setCertificateFormSuccess('');
    setCertificateStudentSearch('');
  };

  const handleCertificateEnrollmentChange = (enrollmentId) => {
    const enrollment = selectedEnrollmentsForCertificate.find((e) => String(e.id) === String(enrollmentId));
    setCertificateFormData((prev) => ({
      ...prev,
      enrollment_id: enrollmentId,
      course_id: enrollment?.course_id || '',
      course_name: enrollment?.course_title || '',
      course_duration: enrollment?.course_duration || ''
    }));
  };

  const handleViewCertificate = (certificate) => {
    setSelectedCertificate(certificate);
    setShowCertificateViewModal(true);
    setCertificateFormError('');
  };

  const handleOpenCertificatePage = (certificate) => {
    if (!certificate) return;

    localStorage.setItem(CERTIFICATE_PREVIEW_KEY, JSON.stringify(certificate));
    window.open('/certificate?preview=admin', '_blank', 'noopener,noreferrer');
  };

  const handleToggleCertificateStatus = async (certificate) => {
    if (!certificate?.id) return;

    const nextStatus = !certificate.is_valid;
    setCertificateActionLoadingId(certificate.id);
    setCertificateFormError('');
    setCertificateFormSuccess('');

    const previousCertificates = certificates;
    const updateCertificates = (list) => list.map((item) => (
      item.id === certificate.id ? { ...item, is_valid: nextStatus } : item
    ));

    setCertificates((prev) => {
      const nextCertificates = updateCertificates(prev);
      localStorage.setItem(CERTIFICATE_CACHE_KEY, JSON.stringify(nextCertificates));
      return nextCertificates;
    });
    if (selectedCertificate?.id === certificate.id) {
      setSelectedCertificate((prev) => (prev ? { ...prev, is_valid: nextStatus } : prev));
    }

    try {
      const result = await AdminUsecase.updateCertificateStatusUsecase(certificate.id, nextStatus);
      if (!result.success) {
        throw new Error(result.error || 'Failed to update certificate status');
      }

      setCertificateFormSuccess(`Certificate ${nextStatus ? 'enabled' : 'disabled'} successfully.`);
    } catch (error) {
      setCertificates(previousCertificates);
      localStorage.setItem(CERTIFICATE_CACHE_KEY, JSON.stringify(previousCertificates));
      if (selectedCertificate?.id === certificate.id) {
        setSelectedCertificate(certificate);
      }
      setCertificateFormError(error.message || 'Failed to update certificate status');
    } finally {
      setCertificateActionLoadingId('');
    }
  };

  useEffect(() => {
    const initializeAdmin = async () => {
      try {
        // Validate admin access
        const validation = await AdminUsecase.validateAdminAccess();

        if (!validation.valid) {
          navigate('/admin/login');
          return;
        }

        setAdminUser(validation.user);

        // Fetch dashboard data
        await fetchDashboardData();

      } catch (error) {
        console.error('Admin initialization error:', error);
        navigate('/admin/login');
      } finally {
        setLoading(false);
      }
    };

    initializeAdmin();
  }, [navigate]);

  const fetchDashboardData = async () => {
    try {
      // Fetch real data from usecases
      const studentsResult = await AdminUsecase.getAllStudentsUsecase();
      const enrollmentsResult = await AdminUsecase.getAllEnrollmentsUsecase();
      const coursesResult = await AdminUsecase.getAllCoursesUsecase();
      const financialResult = await AdminUsecase.getFinancialStatsUsecase();
      const accountsResult = await AdminUsecase.getAccountsUsecase(100, 0);
      const pendingFeesResult = await AdminUsecase.getPendingFeesUsecase(200, 0);
      const certificatesResult = await AdminUsecase.getAllCertificatesUsecase();
      const teachersResult = await AdminUsecase.getAllTeachersUsecase();

      console.log('Courses result:', coursesResult);
      console.log('Courses data:', coursesResult.courses);

      // Set the actual data
      setStudents(studentsResult.students || []);
      setEnrollments(enrollmentsResult.enrollments || []);
      setCourses(coursesResult.courses || []);
      setFinancialStats(financialResult || {});
      setAccounts(accountsResult.accounts || []);
      setPendingFees(pendingFeesResult.fees || []);
      setTeachers(teachersResult.teachers || []);
      const cachedCertificates = JSON.parse(localStorage.getItem(CERTIFICATE_CACHE_KEY) || '[]');
      const mergedCertificates = [...(certificatesResult.certificates || []), ...cachedCertificates].filter(
        (certificate, index, list) => index === list.findIndex((item) => item.id === certificate.id)
      );

      setCertificates(mergedCertificates);

      setStats({
        totalStudents: studentsResult.count || 0,
        totalCourses: coursesResult.count || 0,
        totalEnrollments: enrollmentsResult.count || 0,
        totalRevenue: financialResult.totalRevenue || 0
      });
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      // Use mock data as fallback
      setStats({
        totalStudents: 150,
        totalCourses: 12,
        totalEnrollments: 89,
        totalRevenue: 245000
      });
    }
  };

  // Attendance handlers are encapsulated in StudentAttendacne

  const handleMarkFeeDone = async (feeId) => {
    try {
      const result = await AdminUsecase.markFeeAsPaid(feeId);
      if (result && result.success) {
        setPendingFees((prev) => prev.filter((f) => f.id !== feeId));
      } else {
        console.error('Mark fee paid failed:', result?.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error marking fee as paid:', error);
    }
  };

  const applyStudentStatusChange = async (student, nextStatus) => {
    try {
      const result = await AdminUsecase.updateStudentStatusUsecase(student.id, nextStatus);
      if (result.success) {
        setStudents((prev) => prev.map((item) => (
          item.id === student.id ? { ...item, is_active: nextStatus } : item
        )));
      }
    } catch (error) {
      console.error('Error updating student status:', error);
    } finally {
      setSelectedStudentStatusChange(null);
      setShowStudentStatusModal(false);
    }
  };

  const handleStudentStatusToggle = (student) => {
    if (!student?.id) return;

    const nextStatus = !student.is_active;
    if (!nextStatus) {
      setSelectedStudentStatusChange({ student, nextStatus });
      setShowStudentStatusModal(true);
      return;
    }

    applyStudentStatusChange(student, nextStatus);
  };

  const handleLogout = async () => {
    try {
      await AdminUsecase.adminLogoutUsecase();
      navigate('/admin/login');
    } catch (error) {
      console.error('Logout error:', error);
      // Force logout even if there's an error
      AdminUsecase.clearAdminSession();
      navigate('/admin/login');
    }
  };

  const handleChangePassword = () => {
    navigate('/admin/change-password');
  };

  // Modal handlers
  const resetForms = () => {
    setStudentFormData({
      full_name: '',
      email: '',
      phone_number: '',
      dob: '',
      course_id: '',
      enrollment_mode: 'online',
      payment_mode: 'full',
      total_amount: '',
      installment_count: 3,
      installment_amount: '',
      first_installment_date: ''
    });
    setCourseFormData({
      title: '',
      description: '',
      price: '',
      duration: '',
      category: '',
      level: 'beginner',
      image_url: '',
      is_active: true
    });
    setAccountFormData({ description: '', credit: false, txn_date: new Date().toISOString().split('T')[0], amount: '' });
    setFormError('');
    setFormSuccess('');
    setAccountFormError('');
    setAccountFormSuccess('');
    setEnrollFormData({
      course_id: '',
      enrollment_mode: 'online',
      payment_mode: 'full',
      total_amount: '',
      installment_count: 3,
      installment_amount: '',
      first_installment_date: ''
    });
    setSelectedStudentForEnroll(null);
    setEnrollFormError('');
    setEnrollFormSuccess('');
    setCertificateFormData({
      user_id: '',
      enrollment_id: '',
      course_id: '',
      course_name: '',
      certificate_number: '',
      grade: '',
      instructor_name: '',
      course_duration: '',
      completion_date: '',
      issue_date: '',
      certificate_url: '',
      is_valid: true
    });
    setCertificateFormError('');
    setCertificateFormSuccess('');
  };

  const handleOpenEnrollModal = (student) => {
    setSelectedStudentForEnroll(student);
    setEnrollFormData({
      course_id: '',
      enrollment_mode: 'online',
      payment_mode: 'full',
      total_amount: '',
      installment_count: 3,
      installment_amount: '',
      first_installment_date: ''
    });
    setEnrollFormError('');
    setEnrollFormSuccess('');
    setShowEnrollModal(true);
  };

  const handleEnrollExistingStudent = async (e) => {
    e.preventDefault();
    setEnrollFormError('');
    setEnrollFormSuccess('');

    try {
      if (!selectedStudentForEnroll || !selectedStudentForEnroll.id) {
        setEnrollFormError('No student selected');
        return;
      }
      if (!enrollFormData.course_id) {
        setEnrollFormError('Please select a course');
        return;
      }
      const amt = parseFloat(enrollFormData.total_amount || '0');
      if (Number.isNaN(amt) || amt <= 0) {
        setEnrollFormError('Please enter a valid total amount');
        return;
      }
      if (enrollFormData.payment_mode === 'emi') {
        if (!enrollFormData.installment_count || !enrollFormData.first_installment_date) {
          setEnrollFormError('Please fill in all EMI details');
          return;
        }
      }

      const result = await AdminUsecase.enrollExistingStudentUsecase(
        selectedStudentForEnroll.id,
        enrollFormData
      );

      if (result.success) {
        setEnrollFormSuccess('Student enrolled successfully!');
        await fetchDashboardData();
        setTimeout(() => {
          setShowEnrollModal(false);
          resetForms();
        }, 1200);
      } else {
        setEnrollFormError(result.error || 'Failed to enroll student');
      }
    } catch (error) {
      console.error('Error enrolling student:', error);
      setEnrollFormError('An error occurred while enrolling the student');
    }
  };

  const handleAddStudent = async (e) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');

    try {
      // Validate required fields
      if (!studentFormData.full_name || !studentFormData.email || !studentFormData.course_id || !studentFormData.phone_number || !studentFormData.dob) {
        setFormError('Please fill in all required fields');
        return;
      }

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(studentFormData.email)) {
        setFormError('Please enter a valid email address');
        return;
      }

      // Phone validation
      const phoneRegex = /^[0-9]{10}$/;
      if (!phoneRegex.test(studentFormData.phone_number)) {
        setFormError('Please enter a valid 10-digit phone number');
        return;
      }

      // Date validation (DOB should not be in future)
      const today = new Date();
      const dobDate = new Date(studentFormData.dob);
      if (dobDate >= today) {
        setFormError('Date of birth cannot be today or in the future');
        return;
      }

      // Age validation (minimum 10 years old)
      const age = today.getFullYear() - dobDate.getFullYear();
      if (age < 10) {
        setFormError('Student must be at least 10 years old');
        return;
      }

      // Validate payment mode specific fields
      if (studentFormData.payment_mode === 'emi') {
        if (!studentFormData.installment_count || !studentFormData.installment_amount || !studentFormData.first_installment_date) {
          setFormError('Please fill in all EMI details');
          return;
        }
      } else if (studentFormData.payment_mode === 'full') {
        if (!studentFormData.total_amount) {
          setFormError('Please enter the total amount for full payment');
          return;
        }
      }

      // Amount validation
      if (parseFloat(studentFormData.total_amount) <= 0) {
        setFormError('Total amount must be greater than 0');
        return;
      }

      // Add student logic here - you'll need to implement this in AdminUsecase
      const result = await AdminUsecase.addStudentWithEnrollment(studentFormData);

      if (result.success) {
        setFormSuccess('Student added and enrolled successfully!');
        await fetchDashboardData(); // Refresh data
        setTimeout(() => {
          setShowAddStudentModal(false);
          resetForms();
        }, 1500);
      } else {
        setFormError(result.error || 'Failed to add student');
      }
    } catch (error) {
      console.error('Error adding student:', error);
      setFormError('An error occurred while adding the student');
    }
  };

  const handleAddCourse = async (e) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');

    try {
      // Validate required fields
      if (!courseFormData.title || !courseFormData.price) {
        setFormError('Please fill in all required fields');
        return;
      }

      // Add course logic here - you'll need to implement this in AdminUsecase
      const result = await AdminUsecase.addCourse(courseFormData);

      if (result.success) {
        setFormSuccess('Course added successfully!');
        await fetchDashboardData(); // Refresh data
        setTimeout(() => {
          setShowAddCourseModal(false);
          resetForms();
        }, 1500);
      } else {
        setFormError(result.error || 'Failed to add course');
      }
    } catch (error) {
      console.error('Error adding course:', error);
      setFormError('An error occurred while adding the course');
    }
  };

  const handleAddAccount = async (e) => {
    e.preventDefault();
    setAccountFormError('');
    setAccountFormSuccess('');

    try {
      if (!accountFormData.description || !accountFormData.txn_date) {
        setAccountFormError('Please provide description and date');
        return;
      }
      if (accountFormData.amount === '' || Number.isNaN(parseFloat(accountFormData.amount))) {
        setAccountFormError('Please provide a valid amount');
        return;
      }
      const amtNum = parseFloat(accountFormData.amount);
      if (amtNum <= 0) {
        setAccountFormError('Amount must be greater than 0');
        return;
      }

      const result = await AdminUsecase.addAccountStatementUsecase({
        description: accountFormData.description,
        credit: !!accountFormData.credit,
        txn_date: accountFormData.txn_date,
        amount: amtNum,
      });

      if (result.success) {
        setAccountFormSuccess('Statement added successfully!');
        await fetchDashboardData(); // Refresh
        setTimeout(() => {
          setShowAddAccountModal(false);
          resetForms();
        }, 1200);
      } else {
        setAccountFormError(result.error || 'Failed to add statement');
      }
    } catch (error) {
      console.error('Error adding account statement:', error);
      setAccountFormError('An error occurred while adding the statement');
    }
  };

  const handleCreateCertificate = async (e) => {
    e.preventDefault();
    setCertificateFormError('');
    setCertificateFormSuccess('');

    try {
      if (!certificateFormData.user_id) {
        setCertificateFormError('Please select a student');
        return;
      }
      if (!certificateFormData.enrollment_id) {
        setCertificateFormError('Please select an enrollment');
        return;
      }
      if (!certificateFormData.course_id || !certificateFormData.course_name) {
        setCertificateFormError('Course details are missing from enrollment');
        return;
      }

      const payload = {
        ...certificateFormData,
        issue_date: certificateFormData.issue_date || null,
        completion_date: certificateFormData.completion_date || null
      };

      const result = await AdminUsecase.createCertificateUsecase(payload);
      if (result.success) {
        const selectedStudent = (students || []).find((student) => String(student.id) === String(certificateFormData.user_id));
        const selectedEnrollment = (enrollments || []).find((enrollment) => String(enrollment.id) === String(certificateFormData.enrollment_id));
        const optimisticCertificate = {
          id: result.certificate?.id || `local-${Date.now()}`,
          certificate_number: result.certificate?.certificate_number || certificateFormData.certificate_number || 'Generated',
          student_name: selectedStudent?.full_name || selectedStudent?.name || selectedStudent?.email || 'N/A',
          student_email: selectedStudent?.email || 'N/A',
          student_phone: selectedStudent?.phone_number || 'N/A',
          course_name: certificateFormData.course_name || selectedEnrollment?.course_title || 'N/A',
          grade: certificateFormData.grade || 'A',
          issue_date: certificateFormData.issue_date || new Date().toISOString(),
          is_valid: typeof certificateFormData.is_valid === 'boolean' ? certificateFormData.is_valid : true
        };

        setCertificates((prev) => {
          const nextCertificates = [optimisticCertificate, ...prev.filter((item) => item.id !== optimisticCertificate.id)];
          localStorage.setItem(CERTIFICATE_CACHE_KEY, JSON.stringify(nextCertificates));
          return nextCertificates;
        });
        setCertificateFormSuccess('Certificate created successfully!');
        setCertificateFormData({
          user_id: '',
          enrollment_id: '',
          course_id: '',
          course_name: '',
          certificate_number: '',
          grade: '',
          instructor_name: '',
          course_duration: '',
          completion_date: '',
          issue_date: '',
          certificate_url: '',
          is_valid: true
        });
        setCertificateStudentSearch('');
      } else {
        setCertificateFormError(result.error || 'Failed to create certificate');
      }
    } catch (error) {
      console.error('Error creating certificate:', error);
      setCertificateFormError('An error occurred while creating certificate');
    }
  };



  const handleEditCourse = async (course) => {
    try {
      setEditingCourse(course);
      // Fetch full course details to ensure fields like image_url are present
      const result = await AdminUsecase.getCourseByIdUsecase(course.id);
      const fullCourse = result.success && result.course ? result.course : course;
      setCourseFormData({
        title: fullCourse.title || '',
        description: fullCourse.description || '',
        price: fullCourse.price || '',
        duration: fullCourse.duration || '',
        category: fullCourse.category || '',
        level: (fullCourse.level || 'beginner'),
        image_url: fullCourse.image_url || '',
        is_active: fullCourse.is_active !== false
      });
      setShowEditCourseModal(true);
    } catch (err) {
      console.error('Edit course open error:', err);
      // Fallback to existing course object
      setCourseFormData({
        title: course.title || '',
        description: course.description || '',
        price: course.price || '',
        duration: course.duration || '',
        category: course.category || '',
        level: (course.level || 'beginner'),
        image_url: course.image_url || '',
        is_active: course.is_active !== false
      });
      setShowEditCourseModal(true);
    }
  };

  const handleOpenAddCourse = () => {
    setEditingCourse(null);
    setCourseFormData({
      title: '',
      description: '',
      price: '',
      duration: '',
      category: '',
      level: 'beginner',
      image_url: '',
      is_active: true
    });
    setFormError('');
    setFormSuccess('');
    setShowAddCourseModal(true);
  };

  const handleUpdateCourse = async (e) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');

    try {
      // Update course logic here - you'll need to implement this in AdminUsecase
      const result = await AdminUsecase.updateCourse(editingCourse.id, courseFormData);

      if (result.success) {
        setFormSuccess('Course updated successfully!');
        await fetchDashboardData(); // Refresh data
        setTimeout(() => {
          setShowEditCourseModal(false);
          resetForms();
          setEditingCourse(null);
        }, 1500);
      } else {
        setFormError(result.error || 'Failed to update course');
      }
    } catch (error) {
      console.error('Error updating course:', error);
      setFormError('An error occurred while updating the course');
    }
  };

  const handleTeacherSubmit = async (e) => {
    e.preventDefault();
    setTeacherFormError('');
    setTeacherFormSuccess('');

    try {
      if (!teacherFormData.full_name || !teacherFormData.email) {
        setTeacherFormError('Please fill in name and email');
        return;
      }

      if (teacherModalMode === 'add' && !teacherFormData.password) {
        setTeacherFormError('Password is required for new teacher');
        return;
      }

      const result = teacherModalMode === 'edit'
        ? await AdminUsecase.updateTeacherUsecase(selectedTeacher?.id, teacherFormData)
        : await AdminUsecase.createTeacherUsecase(teacherFormData);

      if (!result.success) {
        setTeacherFormError(result.error || 'Failed to save teacher');
        return;
      }

      setTeacherFormSuccess(
        teacherModalMode === 'edit' ? 'Teacher updated successfully!' : 'Teacher added successfully!'
      );
      await fetchDashboardData();

      setTimeout(() => {
        setShowTeacherModal(false);
        resetTeacherForm();
      }, 1200);
    } catch (error) {
      console.error('Error saving teacher:', error);
      setTeacherFormError('An error occurred while saving teacher');
    }
  };

  const handleDeleteTeacher = async (teacher) => {
    if (!teacher?.id) return;

    const confirmed = window.confirm(`Delete teacher "${teacher.full_name}"?`);
    if (!confirmed) return;

    const result = await AdminUsecase.deleteTeacherUsecase(teacher.id);
    if (result.success) {
      await fetchDashboardData();
      if (selectedTeacher?.id === teacher.id) {
        setShowTeacherModal(false);
        resetTeacherForm();
      }
    }
  };

  if (loading) {
    return (
      <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading admin dashboard...</p>
        </div>
      </Container>
    );
  }



  return (
    <Container fluid>
      {/* Header */}
      <Row className=" text-white  mb-4 mt-3">
        <Col className='bg-primary'>
          <div className="d-flex justify-content-between align-items-center " >
            <div>
              <h2 className="mb-0">Admin Dashboard</h2>
            </div>
            <div className="d-flex gap-2">
              {/* <Button
                variant="outline-light"
                size="sm"
                onClick={handleChangePassword}
              >
                <FaKey className="me-1" />
                Change Password
              </Button> */}
              <Button variant="outline-light" size="sm" onClick={handleLogout}>
                <FaSignOutAlt className="me-1" />
                Logout
              </Button>
            </div>
          </div>
        </Col>
      </Row>

      {/* Stats Cards */}
      {activeTab === 'overview' && (
        <Row className="mb-4">
          <Col md={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <h3 className="text-primary">{stats.totalStudents}</h3>
                <p className="text-muted mb-0">Total Students</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <h3 className="text-success">{stats.totalCourses}</h3>
                <p className="text-muted mb-0">Total Courses</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <h3 className="text-warning">{stats.totalEnrollments}</h3>
                <p className="text-muted mb-0">Total Enrollments</p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <h3 className="text-info">₹{stats.totalRevenue.toLocaleString()}</h3>
                <p className="text-muted mb-0">Total Revenue</p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Navigation Tabs */}
      <Tab.Container activeKey={activeTab} onSelect={setActiveTab}>
        <Nav variant="tabs" className="mb-4">
          <Nav.Item>
            <Nav.Link eventKey="students">Students</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="teachers">Teachers</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="courses">Courses</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="enrollments">Enrollments</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="financial">Financial</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="certificates">Certificates</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="accounts">Accounts</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="attendance">Attendance</Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          {/* Attendance Tab */}
          <Tab.Pane eventKey="attendance">
            <StudentAttendacne students={students} />
          </Tab.Pane>

          {/* Students Tab */}
          <Tab.Pane eventKey="students">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Students Management</h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    size="sm"
                    value={searchStudents}
                    onChange={(e) => setSearchStudents(e.target.value)}
                    style={{ width: '220px' }}
                  />
                  <Button variant="outline-secondary" size="sm" onClick={handleExportStudents}>
                    <FaFileExport className="me-1" />
                    Export
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => setShowAddStudentModal(true)}
                  >
                    <FaPlus className="me-1" />
                    Add Student
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Course</th>
                      <th>Contact</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredStudents() && getFilteredStudents().length > 0 ? getFilteredStudents().map(student => (
                      <tr key={student.id}>
                        <td>{student.id}</td>
                        <td>{student.full_name || student.name || 'N/A'}</td>
                        <td>{student.email}</td>
                        <td>{student.course_title || student.latest_course || 'N/A'}</td>
                        <td>
                          {(() => {
                            const { telHref, waHref } = buildContactLinks(student.phone_number);
                            return (
                              <div className="d-flex align-items-center gap-2">
                                {telHref ? (
                                  <a
                                    href={telHref}
                                    className="btn btn-outline-primary btn-sm"
                                    title="Call"
                                  >
                                    <FaPhoneAlt />
                                  </a>
                                ) : (
                                  <span className="text-muted" title="No phone">
                                    <FaPhoneAlt />
                                  </span>
                                )}
                                {waHref ? (
                                  <a
                                    href={waHref}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-outline-success btn-sm"
                                    title="WhatsApp"
                                  >
                                    <FaWhatsapp />
                                  </a>
                                ) : (
                                  <span className="text-muted" title="Invalid WhatsApp number">
                                    <FaWhatsapp />
                                  </span>
                                )}
                              </div>
                            );
                          })()}
                        </td>
                        <td>
                          <Badge bg={student.is_active ? 'success' : 'secondary'}>
                            {student.is_active ? 'Active' : 'Inactive'}
                          </Badge>
                        </td>
                        <td>
                          <Button
                            variant="outline-primary"
                            size="sm"
                            onClick={() => navigate(`/admin/student/${student.id}`)}
                          >
                            View
                          </Button>
                          <Button
                            variant="outline-success"
                            size="sm"
                            className="ms-2"
                            onClick={() => handleOpenEnrollModal(student)}
                          >
                            Enroll
                          </Button>
                          <Button
                            variant={student.is_active ? 'outline-danger' : 'outline-success'}
                            size="sm"
                            className="ms-2"
                            onClick={() => handleStudentStatusToggle(student)}
                          >
                            {student.is_active ? 'Disable' : 'Enable'}
                          </Button>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">
                          {loading ? 'Loading students...' : 'No students found'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>

          {/* Teachers Tab */}
          <Tab.Pane eventKey="teachers">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <FaChalkboardTeacher className="me-2" />
                  Teacher Management
                </h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search teacher..."
                    size="sm"
                    value={searchTeachers}
                    onChange={(e) => setSearchTeachers(e.target.value)}
                    style={{ width: '220px' }}
                  />
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => openTeacherModal('add')}
                  >
                    <FaPlus className="me-1" />
                    Add Teacher
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Designation</th>
                      <th>Joining Date</th>
                      <th>Salary</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredTeachers().length > 0 ? (
                      getFilteredTeachers().map((teacher) => (
                        <tr key={teacher.id}>
                          <td>{teacher.full_name}</td>
                          <td>{teacher.email}</td>
                          <td>{teacher.phone_number || 'N/A'}</td>
                          <td>{teacher.designation || 'teacher'}</td>
                          <td>{teacher.joining_date ? new Date(teacher.joining_date).toLocaleDateString() : 'N/A'}</td>
                          <td>₹{Number(teacher.salary || 0).toLocaleString()}</td>
                          <td>
                            <Badge bg={teacher.is_active ? 'success' : 'secondary'}>
                              {teacher.is_active ? 'Active' : 'Inactive'}
                            </Badge>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Button variant="outline-primary" size="sm" onClick={() => openTeacherModal('view', teacher)}>
                                <FaEye className="me-1" />
                                View
                              </Button>
                              <Button variant="outline-secondary" size="sm" onClick={() => openTeacherModal('edit', teacher)}>
                                <FaEdit className="me-1" />
                                Edit
                              </Button>
                              <Button variant="outline-danger" size="sm" onClick={() => handleDeleteTeacher(teacher)}>
                                <FaTrash className="me-1" />
                                Delete
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center text-muted">
                          No teachers found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>

          {/* Courses Tab */}
          <Tab.Pane eventKey="courses">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Courses Management</h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    size="sm"
                    value={searchCourses}
                    onChange={(e) => setSearchCourses(e.target.value)}
                    style={{ width: '220px' }}
                  />
                  <Button variant="outline-secondary" size="sm" onClick={handleExportCourses}>
                    <FaFileExport className="me-1" />
                    Export
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={handleOpenAddCourse}
                  >
                    <FaPlus className="me-1" />
                    Add Course
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Course Title</th>
                      <th>Students</th>
                      <th>Price</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredCourses() && getFilteredCourses().length > 0 ? getFilteredCourses().map(course => (
                      <tr key={course.id}>
                        <td><a href={course.image_url} ><img src={course.image_url} height="50px" /></a></td>
                        <td>{course.title}</td>
                        <td>{course.enrollment_count || 0}</td>
                        <td>₹{course.price ? course.price.toLocaleString() : 'N/A'}</td>
                        <td>
                          <Badge bg={course.is_active ? 'success' : 'secondary'}>
                            {course.is_active ? 'Active' : 'Inactive'}
                          </Badge>
                        </td>
                        <td>
                          <Button variant="outline-primary" size="sm" className="me-2">
                            View
                          </Button>
                          <Button
                            variant="outline-secondary"
                            size="sm"
                            onClick={() => handleEditCourse(course)}
                          >
                            <FaEdit className="me-1" />
                            Edit
                          </Button>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="6" className="text-center text-muted">
                          {loading ? 'Loading courses...' : 'No courses found'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>

          {/* Enrollments Tab */}
          <Tab.Pane eventKey="enrollments">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Enrollments Management</h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    size="sm"
                    value={searchEnrollments}
                    onChange={(e) => setSearchEnrollments(e.target.value)}
                    style={{ width: '220px' }}
                  />
                  <Button variant="outline-secondary" size="sm" onClick={handleExportEnrollments}>
                    <FaFileExport className="me-1" />
                    Export
                  </Button>
                  <Button variant="primary" size="sm">Add Enrollment</Button>
                </div>
              </Card.Header>
              <Card.Body>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Student</th>
                      <th>Course</th>
                      <th>Enrollment Date</th>
                      <th>Progress</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredEnrollments() && getFilteredEnrollments().length > 0 ? getFilteredEnrollments().map(enrollment => (
                      <tr key={enrollment.id}>
                        <td>{enrollment.id}</td>
                        <td>{enrollment.student_name || enrollment.user_email || 'N/A'}</td>
                        <td>{enrollment.course_title || 'N/A'}</td>
                        <td>{enrollment.created_at ? new Date(enrollment.created_at).toLocaleDateString() : 'N/A'}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="progress me-2" style={{ width: '60px', height: '8px' }}>
                              <div
                                className="progress-bar"
                                style={{ width: `${enrollment.progress || 0}%` }}
                              ></div>
                            </div>
                            <small>{enrollment.progress || 0}%</small>
                          </div>
                        </td>
                        <td>
                          <Badge bg={enrollment.is_active ? 'success' : 'secondary'}>
                            {enrollment.is_active ? 'Active' : 'Inactive'}
                          </Badge>
                        </td>
                        <td>
                          <Button variant="outline-primary" size="sm" className="me-2">
                            View
                          </Button>
                          <Button variant="outline-secondary" size="sm">
                            Edit
                          </Button>
                        </td>
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">
                          {loading ? 'Loading enrollments...' : 'No enrollments found'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>

          {/* Certificates Tab */}
          <Tab.Pane eventKey="certificates">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">
                  <FaCertificate className="me-2" />
                  Certificates Management
                </h5>
                <Form.Control
                  type="text"
                  placeholder="Search certificate/student/course..."
                  size="sm"
                  value={searchCertificates}
                  onChange={(e) => setSearchCertificates(e.target.value)}
                  style={{ width: '280px' }}
                />
              </Card.Header>
              <Card.Body>
                {certificateFormError && <Alert variant="danger">{certificateFormError}</Alert>}
                {certificateFormSuccess && <Alert variant="success">{certificateFormSuccess}</Alert>}

                <Form onSubmit={handleCreateCertificate}>
                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Search Student</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Search by name, email or phone"
                          value={certificateStudentSearch}
                          onChange={(e) => setCertificateStudentSearch(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Student *</Form.Label>
                        <Form.Select
                          value={certificateFormData.user_id}
                          onChange={(e) => handleCertificateStudentChange(e.target.value)}
                          required
                        >
                          <option value="">Select student</option>
                          {filteredStudentsForCertificate.map((student) => (
                            <option key={student.id} value={student.id}>
                              {(student.full_name || student.name || student.email)} {student.phone_number ? `- ${student.phone_number}` : ''}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Enrollment *</Form.Label>
                        <Form.Select
                          value={certificateFormData.enrollment_id}
                          onChange={(e) => handleCertificateEnrollmentChange(e.target.value)}
                          required
                          disabled={!certificateFormData.user_id}
                        >
                          <option value="">Select enrollment</option>
                          {selectedEnrollmentsForCertificate.map((enrollment) => (
                            <option key={enrollment.id} value={enrollment.id}>
                              {enrollment.course_title} ({enrollment.status})
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Certificate Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Auto-generated if empty"
                          value={certificateFormData.certificate_number}
                          onChange={(e) => setCertificateFormData({ ...certificateFormData, certificate_number: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Grade</Form.Label>
                        <Form.Control
                          type="text"
                          value={certificateFormData.grade}
                          onChange={(e) => setCertificateFormData({ ...certificateFormData, grade: e.target.value })}
                          placeholder="A+, A, B..."
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Completion Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={certificateFormData.completion_date}
                          onChange={(e) => setCertificateFormData({ ...certificateFormData, completion_date: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>Issue Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={certificateFormData.issue_date}
                          onChange={(e) => setCertificateFormData({ ...certificateFormData, issue_date: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="align-items-center">
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Course Name</Form.Label>
                        <Form.Control type="text" value={certificateFormData.course_name} readOnly />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Check
                          type="switch"
                          label="Certificate Valid"
                          checked={!!certificateFormData.is_valid}
                          onChange={(e) => setCertificateFormData({ ...certificateFormData, is_valid: e.target.checked })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3} className="text-end">
                      <Button type="submit" variant="primary" className="mt-2">
                        <FaPlus className="me-1" />
                        Create Certificate
                      </Button>
                    </Col>
                  </Row>
                </Form>

                <hr />

                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Certificate No</th>
                      <th>Student</th>
                      <th>Course</th>
                      <th>Grade</th>
                      <th>Issue Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredCertificates().length > 0 ? (
                      getFilteredCertificates().map((cert) => (
                        <tr key={cert.id}>
                          <td>{cert.certificate_number}</td>
                          <td>{cert.student_name}</td>
                          <td>{cert.course_name}</td>
                          <td>{cert.grade || 'N/A'}</td>
                          <td>{cert.issue_date ? new Date(cert.issue_date).toLocaleDateString() : 'N/A'}</td>
                          <td>
                            <Badge bg={cert.is_valid ? 'success' : 'secondary'}>
                              {cert.is_valid ? 'Valid' : 'Invalid'}
                            </Badge>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={() => handleViewCertificate(cert)}
                              >
                                <FaEye className="me-1" />
                                View
                              </Button>
                              <Button
                                variant={cert.is_valid ? 'outline-danger' : 'outline-success'}
                                size="sm"
                                disabled={certificateActionLoadingId === cert.id}
                                onClick={() => handleToggleCertificateStatus(cert)}
                              >
                                {certificateActionLoadingId === cert.id ? 'Saving...' : (cert.is_valid ? 'Off' : 'On')}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">
                          No certificates found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>

          {/* Accounts Tab */}
          <Tab.Pane eventKey="accounts">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Accounts</h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ width: '220px' }}
                  />
                  <Button variant="outline-secondary" size="sm" onClick={handleExportAccounts}>
                    <FaFileExport className="me-1" />
                    Export
                  </Button>
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => { setAccountFormData(prev => ({ ...prev, txn_date: new Date().toISOString().split('T')[0] })); setShowAddAccountModal(true); }}
                  >
                    <FaPlus className="me-1" />
                    Add Statement
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Amount</th>
                      <th>Balance</th>
                      <th>Type</th>
                      <th>Transaction Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredAccounts() && getFilteredAccounts().length > 0 ? (
                      getFilteredAccounts().map((row) => (
                        <tr key={row.id}>
                          <td>{row.description}</td>
                          <td>{typeof row.amount !== 'undefined' && row.amount !== null ? `₹${Number(row.amount).toLocaleString()}` : '—'}</td>
                          <td>{typeof row.balance !== 'undefined' && row.balance !== null ? `₹${Number(row.balance).toLocaleString()}` : '—'}</td>
                          <td>
                            <Badge bg={row.credit ? 'success' : 'secondary'}>
                              {row.credit ? 'Credit' : 'Debit'}
                            </Badge>
                          </td>
                          <td>{formatDateShort(row.txn_date)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">
                          {loading ? 'Loading accounts...' : 'No account entries found'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>

          {/* Financial Tab */}
          <Tab.Pane eventKey="financial">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Pending Fees</h5>
                <div className="d-flex align-items-center gap-2">
                  <Form.Check
                    type="switch"
                    id="admin-financial-enabled-only"
                    label="Hide Disabled"
                    checked={showOnlyEnabledStudentFees}
                    onChange={(e) => setShowOnlyEnabledStudentFees(e.target.checked)}
                    className="mb-0"
                  />
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    size="sm"
                    value={searchFees}
                    onChange={(e) => setSearchFees(e.target.value)}
                    style={{ width: '220px' }}
                  />
                  <Button variant="outline-secondary" size="sm" onClick={handleExportPendingFees}>
                    <FaFileExport className="me-1" />
                    Export
                  </Button>
                </div>
              </Card.Header>
              <Card.Body>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Student</th>
                      <th>Course</th>
                      <th>Installment</th>
                      <th>Amount</th>
                      <th>Due Date</th>
                      <th>Status</th>
                      <th>Contact</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredPendingFees() && getFilteredPendingFees().length > 0 ? (
                      getFilteredPendingFees().map((fee) => {
                        const overdue = fee.status === 'overdue' || (fee.due_date && new Date(fee.due_date) < new Date());
                        return (
                          <tr key={fee.id}>
                            <td>{fee.student_name}</td>
                            <td>{fee.course_title}</td>
                            <td>{fee.installment_number}/{fee.total_installments}</td>
                            <td>₹{Number(fee.amount).toLocaleString()}</td>
                            <td>{formatDateShort(fee.due_date)}</td>
                            <td>
                              <Badge bg={overdue ? 'danger' : 'warning'}>{overdue ? 'Overdue' : 'Pending'}</Badge>
                            </td>
                            <td>
                              {(() => {
                                const { telHref, waHref } = buildContactLinks(fee.phone_number);
                                return (
                                  <div className="d-flex align-items-center gap-2">
                                    {telHref ? (
                                      <a
                                        href={telHref}
                                        className="btn btn-outline-primary btn-sm"
                                        title="Call"
                                      >
                                        <FaPhoneAlt />
                                      </a>
                                    ) : (
                                      <span className="text-muted" title="No phone">
                                        <FaPhoneAlt />
                                      </span>
                                    )}
                                    {waHref ? (
                                      <a
                                        href={waHref}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-success btn-sm"
                                        title="WhatsApp"
                                      >
                                        <FaWhatsapp />
                                      </a>
                                    ) : (
                                      <span className="text-muted" title="Invalid WhatsApp number">
                                        <FaWhatsapp />
                                      </span>
                                    )}
                                  </div>
                                );
                              })()}
                              {/* {(() => {
                                const { telHref, waHref } = buildContactLinks(fee.phone_number);
                                return (
                                  <div className="d-flex align-items-center gap-2">
                                    {telHref ? (
                                      <a href={telHref} className="text-primary" title="Call">
                                        <FaPhoneAlt />
                                      </a>
                                    ) : (
                                      <FaPhoneAlt className="text-muted" title="No phone" />
                                    )}
                                    {waHref ? (
                                      <a href={waHref} target="_blank" rel="noopener noreferrer" className="text-success" title="WhatsApp">
                                        <FaWhatsapp />
                                      </a>
                                    ) : (
                                      <FaWhatsapp className="text-muted" title="No WhatsApp" />
                                    )}
                                  </div>
                                );
                              })()} */}
                            </td>
                            <td>
                              <Button size="sm" variant="success" onClick={() => handleMarkFeeDone(fee.id)}>Mark Done</Button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center text-muted">
                          {loading ? 'Loading pending fees...' : 'No pending fees'}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>

      {/* Add Student Modal */}
      <Modal show={showAddStudentModal} onHide={() => setShowAddStudentModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add New Student</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formError && <Alert variant="danger">{formError}</Alert>}
          {formSuccess && <Alert variant="success">{formSuccess}</Alert>}
          <Form>
            {/* Personal Information */}
            <h6 className="mb-3 text-primary">Personal Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={studentFormData.full_name}
                    onChange={(e) => setStudentFormData({ ...studentFormData, full_name: e.target.value })}
                    placeholder="Enter full name"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    type="email"
                    value={studentFormData.email}
                    onChange={(e) => setStudentFormData({ ...studentFormData, email: e.target.value })}
                    placeholder="Enter email address"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number *</Form.Label>
                  <Form.Control
                    type="tel"
                    value={studentFormData.phone_number}
                    onChange={(e) => setStudentFormData({ ...studentFormData, phone_number: e.target.value })}
                    placeholder="Enter phone number"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Date of Birth *</Form.Label>
                  <Form.Control
                    type="date"
                    value={studentFormData.dob}
                    onChange={(e) => setStudentFormData({ ...studentFormData, dob: e.target.value })}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>

            </Row>

            {/* Course Information */}
            <h6 className="mb-3 text-primary mt-4">Course Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Course to Enroll *</Form.Label>
                  {console.log('Courses available for dropdown:', courses, 'Length:', courses?.length)}
                  <Form.Select
                    value={studentFormData.course_id && studentFormData.enrollment_mode ? `${studentFormData.course_id}-${studentFormData.enrollment_mode}` : ''}
                    onChange={(e) => {
                      console.log('Course dropdown changed:', e.target.value);
                      console.log('Available courses:', courses);

                      if (e.target.value === '') {
                        setStudentFormData({
                          ...studentFormData,
                          course_id: '',
                          enrollment_mode: '',
                          total_amount: ''
                        });
                        return;
                      }

                      // Use a different separator to avoid conflicts with UUID hyphens
                      const lastPipeIndex = e.target.value.lastIndexOf('|');
                      const courseId = e.target.value.substring(0, lastPipeIndex);
                      const enrollmentMode = e.target.value.substring(lastPipeIndex + 1);

                      console.log('Parsed courseId:', courseId, 'enrollmentMode:', enrollmentMode);
                      console.log('Course IDs in array:', courses.map(c => ({ id: c.id, type: typeof c.id })));
                      console.log('Looking for courseId:', courseId, 'type:', typeof courseId);

                      // Find the selected course
                      const selectedCourse = courses.find(c => c.id.toString() === courseId.toString());

                      console.log('Final selected course:', selectedCourse);
                      console.log('Course price:', selectedCourse?.price);

                      const coursePrice = selectedCourse?.price || '';
                      console.log('Setting total_amount to:', coursePrice);

                      setStudentFormData({
                        ...studentFormData,
                        course_id: courseId,
                        enrollment_mode: enrollmentMode,
                        total_amount: coursePrice.toString()
                      });
                    }}
                    required
                  >
                    <option value="">Select a course and mode</option>
                    {courses && courses.length > 0 ? courses.map(course => (
                      <React.Fragment key={course.id}>
                        <option value={`${course.id}|online`}>
                          {course.title} - Online - ₹{course.price}
                        </option>
                        <option value={`${course.id}|offline`}>
                          {course.title} - Offline - ₹{course.price}
                        </option>
                      </React.Fragment>
                    )) : (
                      <option disabled>Loading courses...</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                {studentFormData.course_id && (
                  <div className="mt-3 p-3 bg-light rounded">
                    <h6 className="text-primary mb-2">Selected Course Details</h6>

                    <div className="mb-1">
                      <strong>Course Name:</strong> {
                        courses.find(c => c.id.toString() === studentFormData.course_id.toString())?.title || 'Course not found'
                      }
                    </div>
                    <div className="mb-1">
                      <strong>Enrollment Mode:</strong> {
                        studentFormData.enrollment_mode ?
                          studentFormData.enrollment_mode.charAt(0).toUpperCase() + studentFormData.enrollment_mode.slice(1) :
                          'Not selected'
                      }
                    </div>

                  </div>
                )}
              </Col>
            </Row>

            {/* Payment Information */}
            <h6 className="mb-3 text-primary mt-4">Payment Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Mode *</Form.Label>
                  <Form.Select
                    value={studentFormData.payment_mode}
                    onChange={(e) => {
                      const paymentMode = e.target.value;
                      setStudentFormData({
                        ...studentFormData,
                        payment_mode: paymentMode,
                        // Reset EMI fields when switching to full payment
                        installment_count: paymentMode === 'emi' ? 3 : '',
                        installment_amount: '',
                        first_installment_date: ''
                      });
                    }}
                    required
                  >
                    <option value="full">Full Payment</option>
                    <option value="emi">EMI (Installments)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Amount (₹) *</Form.Label>
                  <Form.Control
                    type="number"
                    value={studentFormData.total_amount}
                    onChange={(e) => {
                      const totalAmount = e.target.value;
                      setStudentFormData({
                        ...studentFormData,
                        total_amount: totalAmount,
                        // Auto-calculate installment amount if EMI mode
                        installment_amount: studentFormData.payment_mode === 'emi' && studentFormData.installment_count
                          ? (totalAmount / studentFormData.installment_count).toFixed(2)
                          : studentFormData.installment_amount
                      });
                    }}
                    placeholder="Enter total amount"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* EMI Details - Show only when EMI is selected */}
            {studentFormData.payment_mode === 'emi' && (
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>EMI Duration (Months) *</Form.Label>
                    <Form.Select
                      value={studentFormData.installment_count}
                      onChange={(e) => {
                        const installmentCount = e.target.value;
                        setStudentFormData({
                          ...studentFormData,
                          installment_count: installmentCount,
                          installment_amount: studentFormData.total_amount && installmentCount
                            ? (studentFormData.total_amount / installmentCount).toFixed(2)
                            : ''
                        });
                      }}
                      required
                    >
                      <option value="">Select Months</option>
                      <option value="1">1 Month</option>
                      <option value="2">2 Months</option>
                      <option value="3">3 Months</option>
                      <option value="4">4 Months</option>
                      <option value="5">5 Months</option>
                      <option value="6">6 Months</option>
                      <option value="7">7 Months</option>
                      <option value="8">8 Months</option>
                      <option value="9">9 Months</option>
                      <option value="10">10 Months</option>
                      <option value="11">11 Months</option>
                      <option value="12">12 Months</option>
                      <option value="15">15 Months</option>
                      <option value="18">18 Months</option>
                      <option value="24">24 Months</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Installment Amount (₹) *</Form.Label>
                    <Form.Control
                      type="number"
                      value={studentFormData.installment_amount}
                      onChange={(e) => setStudentFormData({ ...studentFormData, installment_amount: e.target.value })}
                      placeholder="Auto-calculated"
                      required
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Installment Date *</Form.Label>
                    <Form.Control
                      type="date"
                      value={studentFormData.first_installment_date}
                      onChange={(e) => setStudentFormData({ ...studentFormData, first_installment_date: e.target.value })}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddStudentModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddStudent}>
            Add Student & Enroll
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Enroll Course Modal (existing student) */}
      <Modal show={showEnrollModal} onHide={() => setShowEnrollModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Enroll Course{selectedStudentForEnroll ? ` — ${selectedStudentForEnroll.full_name || selectedStudentForEnroll.name || selectedStudentForEnroll.email}` : ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {enrollFormError && <Alert variant="danger">{enrollFormError}</Alert>}
          {enrollFormSuccess && <Alert variant="success">{enrollFormSuccess}</Alert>}
          <Form>
            {/* Course Information */}
            <h6 className="mb-3 text-primary">Course Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Course to Enroll *</Form.Label>
                  <Form.Select
                    value={enrollFormData.course_id && enrollFormData.enrollment_mode ? `${enrollFormData.course_id}|${enrollFormData.enrollment_mode}` : ''}
                    onChange={(e) => {
                      if (e.target.value === '') {
                        setEnrollFormData({
                          ...enrollFormData,
                          course_id: '',
                          enrollment_mode: 'online',
                          total_amount: ''
                        });
                        return;
                      }
                      const lastPipeIndex = e.target.value.lastIndexOf('|');
                      const courseId = e.target.value.substring(0, lastPipeIndex);
                      const enrollmentMode = e.target.value.substring(lastPipeIndex + 1);
                      const selectedCourse = courses.find(c => c.id.toString() === courseId.toString());
                      const coursePrice = selectedCourse?.price || '';
                      setEnrollFormData({
                        ...enrollFormData,
                        course_id: courseId,
                        enrollment_mode: enrollmentMode,
                        total_amount: coursePrice.toString(),
                        installment_amount: enrollFormData.payment_mode === 'emi' && enrollFormData.installment_count
                          ? (coursePrice / enrollFormData.installment_count).toFixed(2)
                          : ''
                      });
                    }}
                    required
                  >
                    <option value="">Select a course and mode</option>
                    {courses && courses.length > 0 ? courses.map(course => (
                      <React.Fragment key={course.id}>
                        <option value={`${course.id}|online`}>
                          {course.title} - Online - ₹{course.price}
                        </option>
                        <option value={`${course.id}|offline`}>
                          {course.title} - Offline - ₹{course.price}
                        </option>
                      </React.Fragment>
                    )) : (
                      <option disabled>Loading courses...</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                {enrollFormData.course_id && (
                  <div className="mt-3 p-3 bg-light rounded">
                    <h6 className="text-primary mb-2">Selected Course Details</h6>
                    <div className="mb-1">
                      <strong>Course Name:</strong> {
                        courses.find(c => c.id.toString() === enrollFormData.course_id.toString())?.title || 'Course not found'
                      }
                    </div>
                    <div className="mb-1">
                      <strong>Enrollment Mode:</strong> {
                        enrollFormData.enrollment_mode ?
                          enrollFormData.enrollment_mode.charAt(0).toUpperCase() + enrollFormData.enrollment_mode.slice(1) :
                          'Not selected'
                      }
                    </div>
                  </div>
                )}
              </Col>
            </Row>

            {/* Payment Information */}
            <h6 className="mb-3 text-primary mt-4">Payment Information</h6>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Payment Mode *</Form.Label>
                  <Form.Select
                    value={enrollFormData.payment_mode}
                    onChange={(e) => {
                      const paymentMode = e.target.value;
                      setEnrollFormData({
                        ...enrollFormData,
                        payment_mode: paymentMode,
                        installment_count: paymentMode === 'emi' ? (enrollFormData.installment_count || 3) : 3,
                        installment_amount: paymentMode === 'emi' && enrollFormData.total_amount && enrollFormData.installment_count
                          ? (enrollFormData.total_amount / enrollFormData.installment_count).toFixed(2)
                          : '',
                        first_installment_date: ''
                      });
                    }}
                    required
                  >
                    <option value="full">Full Payment</option>
                    <option value="emi">EMI (Installments)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Total Amount (₹) *</Form.Label>
                  <Form.Control
                    type="number"
                    value={enrollFormData.total_amount}
                    onChange={(e) => {
                      const totalAmount = e.target.value;
                      setEnrollFormData({
                        ...enrollFormData,
                        total_amount: totalAmount,
                        installment_amount: enrollFormData.payment_mode === 'emi' && enrollFormData.installment_count
                          ? (totalAmount / enrollFormData.installment_count).toFixed(2)
                          : ''
                      });
                    }}
                    placeholder="Enter total amount"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* EMI Details - Show only when EMI is selected */}
            {enrollFormData.payment_mode === 'emi' && (
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>EMI Duration (Months) *</Form.Label>
                    <Form.Select
                      value={enrollFormData.installment_count}
                      onChange={(e) => {
                        const installmentCount = e.target.value;
                        setEnrollFormData({
                          ...enrollFormData,
                          installment_count: installmentCount,
                          installment_amount: enrollFormData.total_amount && installmentCount
                            ? (enrollFormData.total_amount / installmentCount).toFixed(2)
                            : ''
                        });
                      }}
                      required
                    >
                      <option value="">Select Months</option>
                      <option value="1">1 Month</option>
                      <option value="2">2 Months</option>
                      <option value="3">3 Months</option>
                      <option value="4">4 Months</option>
                      <option value="5">5 Months</option>
                      <option value="6">6 Months</option>
                      <option value="7">7 Months</option>
                      <option value="8">8 Months</option>
                      <option value="9">9 Months</option>
                      <option value="10">10 Months</option>
                      <option value="11">11 Months</option>
                      <option value="12">12 Months</option>
                      <option value="15">15 Months</option>
                      <option value="18">18 Months</option>
                      <option value="24">24 Months</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Installment Amount (₹) *</Form.Label>
                    <Form.Control
                      type="number"
                      value={enrollFormData.installment_amount}
                      onChange={(e) => setEnrollFormData({ ...enrollFormData, installment_amount: e.target.value })}
                      placeholder="Auto-calculated"
                      required
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>First Installment Date *</Form.Label>
                    <Form.Control
                      type="date"
                      value={enrollFormData.first_installment_date}
                      onChange={(e) => setEnrollFormData({ ...enrollFormData, first_installment_date: e.target.value })}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEnrollModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEnrollExistingStudent} disabled={!selectedStudentForEnroll}>
            Enroll Course
          </Button>
        </Modal.Footer>
      </Modal>



      {/* Add Course Modal */}
      <Modal show={showAddCourseModal} onHide={() => setShowAddCourseModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Add New Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formError && <Alert variant="danger">{formError}</Alert>}
          {formSuccess && <Alert variant="success">{formSuccess}</Alert>}
          <Form>
            <Row>
              <Col md={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Course Title *</Form.Label>
                  <Form.Control
                    type="text"
                    value={courseFormData.title}
                    onChange={(e) => setCourseFormData({ ...courseFormData, title: e.target.value })}
                    placeholder="Enter course title"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Price (₹) *</Form.Label>
                  <Form.Control
                    type="number"
                    value={courseFormData.price}
                    onChange={(e) => setCourseFormData({ ...courseFormData, price: e.target.value })}
                    placeholder="Enter price"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Duration</Form.Label>
                  <Form.Control
                    type="text"
                    value={courseFormData.duration}
                    onChange={(e) => setCourseFormData({ ...courseFormData, duration: e.target.value })}
                    placeholder="e.g., 3 months, 6 weeks"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    value={courseFormData.category}
                    onChange={(e) => setCourseFormData({ ...courseFormData, category: e.target.value })}
                    required
                  >
                    <option value="">Select category</option>
                    {courseCategoryOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                    {courseFormData.category && !courseCategoryOptions.some(opt => opt.value === courseFormData.category) && (
                      <option value={courseFormData.category}>{courseFormData.category}</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Level</Form.Label>
                  <Form.Select
                    value={courseFormData.level}
                    onChange={(e) => setCourseFormData({ ...courseFormData, level: e.target.value })}
                    required
                  >
                    <option value="beginner">Beginner</option>
                    <option value="intermediate">Intermediate</option>
                    <option value="advanced">Advanced</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Image URL</Form.Label>
                  <Form.Control
                    type="text"
                    value={courseFormData.image_url}
                    onChange={(e) => setCourseFormData({ ...courseFormData, image_url: e.target.value })}
                    placeholder="https://example.com/image.jpg"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={courseFormData.description}
                onChange={(e) => setCourseFormData({ ...courseFormData, description: e.target.value })}
                placeholder="Enter course description"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Course is active"
                checked={courseFormData.is_active}
                onChange={(e) => setCourseFormData({ ...courseFormData, is_active: e.target.checked })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddCourseModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddCourse}>
            Add Course
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Course Modal */}
      <Modal show={showEditCourseModal} onHide={() => setShowEditCourseModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formError && <Alert variant="danger">{formError}</Alert>}
          {formSuccess && <Alert variant="success">{formSuccess}</Alert>}
          <Form>
            <Row>
              <Col md={8}>
                <Form.Group className="mb-3">
                  <Form.Label>Course Title *</Form.Label>
                  <Form.Control
                    type="text"
                    value={courseFormData.title}
                    onChange={(e) => setCourseFormData({ ...courseFormData, title: e.target.value })}
                    placeholder="Enter course title"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Price (₹) *</Form.Label>
                  <Form.Control
                    type="number"
                    value={courseFormData.price}
                    onChange={(e) => setCourseFormData({ ...courseFormData, price: e.target.value })}
                    placeholder="Enter price"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Duration</Form.Label>
                  <Form.Control
                    type="text"
                    value={courseFormData.duration}
                    onChange={(e) => setCourseFormData({ ...courseFormData, duration: e.target.value })}
                    placeholder="e.g., 3 months, 6 weeks"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    value={courseFormData.category}
                    onChange={(e) => setCourseFormData({ ...courseFormData, category: e.target.value })}
                    required
                  >
                    <option value="">Select category</option>
                    {courseCategoryOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                    {courseFormData.category && !courseCategoryOptions.some(opt => opt.value === courseFormData.category) && (
                      <option value={courseFormData.category}>{courseFormData.category}</option>
                    )}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Level</Form.Label>
                  <Form.Select
                    value={courseFormData.level}
                    onChange={(e) => setCourseFormData({ ...courseFormData, level: e.target.value })}
                    required
                  >
                    <option value="beginner">Beginner</option>
                    <option value="intermediate">Intermediate</option>
                    <option value="advanced">Advanced</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Image URL</Form.Label>
                  <Form.Control
                    type="text"
                    value={courseFormData.image_url}
                    onChange={(e) => setCourseFormData({ ...courseFormData, image_url: e.target.value })}
                    placeholder="https://example.com/image.jpg"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={courseFormData.description}
                onChange={(e) => setCourseFormData({ ...courseFormData, description: e.target.value })}
                placeholder="Enter course description"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="checkbox"
                label="Course is active"
                checked={courseFormData.is_active}
                onChange={(e) => setCourseFormData({ ...courseFormData, is_active: e.target.checked })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditCourseModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdateCourse}>
            Update Course
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Account Statement Modal */}
      <Modal show={showAddAccountModal} onHide={() => setShowAddAccountModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Account Statement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {accountFormError && <Alert variant="danger">{accountFormError}</Alert>}
          {accountFormSuccess && <Alert variant="success">{accountFormSuccess}</Alert>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Description *</Form.Label>
              <Form.Control
                type="text"
                value={accountFormData.description}
                onChange={(e) => setAccountFormData({ ...accountFormData, description: e.target.value })}
                placeholder="Enter description"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Amount (₹) *</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                value={accountFormData.amount}
                onChange={(e) => setAccountFormData({ ...accountFormData, amount: e.target.value })}
                placeholder="Enter amount"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                type="switch"
                label="Credit"
                checked={!!accountFormData.credit}
                onChange={(e) => setAccountFormData({ ...accountFormData, credit: e.target.checked })}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Transaction Date *</Form.Label>
              <Form.Control
                type="date"
                value={accountFormData.txn_date}
                onChange={(e) => setAccountFormData({ ...accountFormData, txn_date: e.target.value })}
                required
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddAccountModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAddAccount}>
            Add Statement
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showStudentStatusModal}
        onHide={() => {
          setShowStudentStatusModal(false);
          setSelectedStudentStatusChange(null);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Disable Student</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedStudentStatusChange?.student ? (
            <div>
              Are you sure you want to disable{' '}
              <strong>{selectedStudentStatusChange.student.full_name || selectedStudentStatusChange.student.name || 'this student'}</strong>?
              Disabled students will be hidden from attendance for admin and teacher.
            </div>
          ) : (
            <div className="text-muted">No student selected.</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowStudentStatusModal(false);
              setSelectedStudentStatusChange(null);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              if (selectedStudentStatusChange?.student) {
                applyStudentStatusChange(
                  selectedStudentStatusChange.student,
                  selectedStudentStatusChange.nextStatus
                );
              }
            }}
          >
            Disable Student
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showTeacherModal}
        onHide={() => {
          setShowTeacherModal(false);
          resetTeacherForm();
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {teacherModalMode === 'add' && 'Add Teacher'}
            {teacherModalMode === 'edit' && 'Edit Teacher'}
            {teacherModalMode === 'view' && 'View Teacher'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {teacherFormError && <Alert variant="danger">{teacherFormError}</Alert>}
          {teacherFormSuccess && <Alert variant="success">{teacherFormSuccess}</Alert>}

          <Form onSubmit={handleTeacherSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={teacherFormData.full_name}
                    onChange={(e) => setTeacherFormData({ ...teacherFormData, full_name: e.target.value })}
                    disabled={teacherModalMode === 'view'}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email *</Form.Label>
                  <Form.Control
                    type="email"
                    value={teacherFormData.email}
                    onChange={(e) => setTeacherFormData({ ...teacherFormData, email: e.target.value })}
                    disabled={teacherModalMode === 'view'}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={teacherFormData.phone_number}
                    onChange={(e) => setTeacherFormData({ ...teacherFormData, phone_number: e.target.value })}
                    disabled={teacherModalMode === 'view'}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Joining Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={teacherFormData.joining_date}
                    onChange={(e) => setTeacherFormData({ ...teacherFormData, joining_date: e.target.value })}
                    disabled={teacherModalMode === 'view'}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Salary</Form.Label>
                  <Form.Control
                    type="number"
                    min="0"
                    value={teacherFormData.salary}
                    onChange={(e) => setTeacherFormData({ ...teacherFormData, salary: e.target.value })}
                    disabled={teacherModalMode === 'view'}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Designation</Form.Label>
                  <Form.Control
                    type="text"
                    value={teacherFormData.designation}
                    onChange={(e) => setTeacherFormData({ ...teacherFormData, designation: e.target.value })}
                    disabled={teacherModalMode === 'view'}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>
                {teacherModalMode === 'edit' ? 'New Password' : 'Password'}
                {teacherModalMode === 'edit' ? ' (optional)' : ' *'}
              </Form.Label>
              <Form.Control
                type="password"
                value={teacherFormData.password}
                onChange={(e) => setTeacherFormData({ ...teacherFormData, password: e.target.value })}
                disabled={teacherModalMode === 'view'}
                placeholder={teacherModalMode === 'edit' ? 'Leave blank to keep current password' : 'Enter password'}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={teacherFormData.address}
                onChange={(e) => setTeacherFormData({ ...teacherFormData, address: e.target.value })}
                disabled={teacherModalMode === 'view'}
              />
            </Form.Group>

            <Form.Group className="mb-0">
              <Form.Check
                type="switch"
                label="Teacher Active"
                checked={!!teacherFormData.is_active}
                onChange={(e) => setTeacherFormData({ ...teacherFormData, is_active: e.target.checked })}
                disabled={teacherModalMode === 'view'}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowTeacherModal(false);
              resetTeacherForm();
            }}
          >
            Close
          </Button>
          {teacherModalMode !== 'view' && (
            <Button variant="primary" onClick={handleTeacherSubmit}>
              {teacherModalMode === 'edit' ? 'Update Teacher' : 'Add Teacher'}
            </Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={showCertificateViewModal} onHide={() => setShowCertificateViewModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Certificate Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCertificate ? (
            <div className="d-grid gap-2">
              <div><strong>Certificate No:</strong> {selectedCertificate.certificate_number || 'N/A'}</div>
              <div><strong>Student:</strong> {selectedCertificate.student_name || 'N/A'}</div>
              <div><strong>Course:</strong> {selectedCertificate.course_name || 'N/A'}</div>
              <div><strong>Grade:</strong> {selectedCertificate.grade || 'N/A'}</div>
              <div><strong>Issue Date:</strong> {selectedCertificate.issue_date ? new Date(selectedCertificate.issue_date).toLocaleString() : 'N/A'}</div>
              <div><strong>Completion Date:</strong> {selectedCertificate.completion_date ? new Date(selectedCertificate.completion_date).toLocaleDateString() : 'N/A'}</div>
              <div>
                <strong>Status:</strong>{' '}
                <Badge bg={selectedCertificate.is_valid ? 'success' : 'secondary'}>
                  {selectedCertificate.is_valid ? 'Valid' : 'Invalid'}
                </Badge>
              </div>
            </div>
          ) : (
            <div className="text-muted">No certificate selected</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCertificateViewModal(false)}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => handleOpenCertificatePage(selectedCertificate)}
            disabled={!selectedCertificate}
          >
            Show Certificate
          </Button>
        </Modal.Footer>
      </Modal>

    </Container>
  );
};

export default AdminDashboard;
